<template>
    <div class="container my-4">
        <div class="row">
            <div class="col-md-12 col-12">
                <h1 class="mb-4">{{ $t('home_title') }}</h1>
            </div>
            <div class="col-md-6 col-12 boxes-box-col">
                <router-link :to="{ name: 'airport-transfers.index' }">
                    <div class="boxes-box" style="background-image: url('/images/airport-transfers.jpg');">
                        <h2>Szczecin - Goleniów <font-awesome-icon icon="plane" class="in-text-icon" />️ -&nbsp;Szczecin</h2>
                        <p><!-- description --></p>
                        <div class="boxes-button">
                            <font-awesome-icon icon="arrow-right" />
                        </div>
                    </div>
                </router-link>
            </div>

            <div class="col-md-6 col-12 boxes-box-col">
                <router-link :to="{ name: 'berbus.index' }">
                    <div class="boxes-box" style="background-image: url('/images/berbus.jpg');">
                        <h2>BERBUS<br>Szczecin - Berlin <font-awesome-icon icon="plane" class="in-text-icon" />️ -&nbsp;Szczecin</h2>
                        <p><!-- description --></p>
                        <div class="boxes-button">
                            <font-awesome-icon icon="arrow-right" />
                        </div>
                    </div>
                </router-link>
            </div>

            <div class="col-md-6 col-12 boxes-box-col">
                <router-link :to="{ name: 'business-taxi.index' }">
                    <div class="boxes-box" style="background-image: url('/images/business-taxi.jpg');">
                        <h2>{{ $t('offer_types.business_taxi') }}</h2>
                        <p><!-- description --></p>
                        <div class="boxes-button">
                            <font-awesome-icon icon="arrow-right" />
                        </div>
                    </div>
                </router-link>
            </div>

            <div class="col-md-6 col-12 boxes-box-col" v-if="!isCompany">
                <router-link :to="{ name: 'smart-taxi.index' }">
                    <div class="boxes-box" style="background-image: url('/images/family-airport-taxi.jpg');">
                        <h2>{{ $t('offer_types.family_airport_taxi') }}</h2>
                        <p><!-- description --></p>
                        <div class="boxes-button">
                            <font-awesome-icon icon="arrow-right" />
                        </div>
                    </div>
                </router-link>
            </div>

            <div class="col-md-6 col-12 boxes-box-col">
                <router-link :to="{ name: 'coaches.index' }">
                    <div class="boxes-box" style="background-image: url('/images/coaches-625x350.png');">
                        <h2>{{ $t('offer_types.coaches') }}</h2>
                        <p><!-- description --></p>
                        <div class="boxes-button">
                            <font-awesome-icon icon="arrow-right" />
                        </div>
                    </div>
                </router-link>
            </div>

            <div class="col-md-6 col-12 boxes-box-col d-none">
                <router-link :to="{ name: 'business-travel-management.index' }">
                    <div class="boxes-box" style="background-image: url('/images/business-travel-management.jpg');">
                        <h2>{{ $t('offer_types.business_travel_management') }}</h2>
                        <p><!-- description --></p>
                        <div class="boxes-button">
                            <font-awesome-icon icon="arrow-right" />
                        </div>
                    </div>
                </router-link>
            </div>
        </div>
    </div>
</template>

<script>
    import toastr from 'toastr';
    import {mapGetters} from 'vuex';

    export default {
        data() {
            return {};
        },

        computed: {
            ...mapGetters({
                isCompany: 'user/isCompany',
            }),
        },

        created() {
            if(window.APP.authMessages.length) {
                toastr.info(window.APP.authMessages);
            }
        },

        methods: {},
    };
</script>

<style scoped>
    h1{
        text-align: center;
        font-size: 26px;
        color: #024659;
        font-weight: 600;
    }

    .boxes-box {
        width: 100%;
        height: 350px;
        background-position: top center;
        background-size: cover;
        background-repeat: no-repeat;
        padding: 25px;
        margin-bottom: 25px;
        position: relative;
    }

    .boxes-box::before {
        content: '';
        position: absolute;
        background: linear-gradient(119.12deg, rgba(12,45,64,0.9) 0%, rgba(76,14,14,0.5) 100%);
        width: 100%;
        height: 100%;
        z-index: 2;
        top: 0;
        left: 0;
    }

    .boxes-box-col a {
        color: #ffffff;
    }

    .boxes-box h2 {
        font-size: 24px;
        font-weight: 900;
        letter-spacing: 0.31px;
        line-height: 29px;
        color: #ffffff;
        position: relative;
        z-index: 3;
    }

    .boxes-box h2 svg {
        font-size: 24px;
        padding-left: 5px;
    }

    .boxes-box p {
        font-size: 16px;
        letter-spacing: 0.21px;
        line-height: 24px;
        color: #ffffff;
        position: relative;
        z-index: 3;
    }

    .boxes-box .boxes-button {
        width: 45px;
        height: 45px;
        padding-top: 5px;
        border-radius: 2px;
        border: solid 1px #ffffff;
        text-align: center;
        position: absolute;
        cursor: pointer;
        bottom: 25px;
        z-index: 3;
        font-size: 1.25rem;
        color: #ffffff;
    }
</style>
